import { render, staticRenderFns } from "./UserUsergroups.vue?vue&type=template&id=222d6cb6"
import script from "./UserUsergroups.vue?vue&type=script&lang=js"
export * from "./UserUsergroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports